import Box from '@mui/material/Box'
import Link from 'next/link'
import { resolveHref } from '@/utilites/resolveHref'

const LINK_STYLE = {
    textDecoration: 'none',
    fontSize: '1rem',
    fontFamily: 'MonaSansCondensed, sans-serif',
}

interface MenuLink {
    label: string
    url: string
}

interface MenuProps {
    menuLinks: MenuLink[]
    tel?: string
    button?: { link?: string; text?: string }
    color?: string
}

const Menu = ({ menuLinks }: MenuProps) => {
    return (
        <Box
            component={'ul'}
            sx={{
                display: 'grid',
                listStyle: 'none',
                width: '100%',
                gap: 1,
                gridTemplateColumns: {
                    xs: '1fr',
                    md: 'repeat(3, 1fr)',
                    lg: 'repeat(4, 1fr)',
                },
            }}
        >
            {menuLinks.map((link) => (
                <li key={link.label}>
                    <Link
                        href={resolveHref(link.url)}
                        style={{ ...LINK_STYLE, color: '#fff'}}
                    >
                        {link.label}
                    </Link>
                </li>
            ))}
        </Box>
    )
}

export default Menu


